// Source/Article-Suggestions/Component.ts
import { Swiper } from "Swiper";

// Source/Article-Suggestions/Config.ts
var Config = {
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 32
    },
    1000: {
      slidesPerView: 3,
      spaceBetween: 44
    }
  }
};

// Source/Article-Suggestions/Component.ts
class ArticleSuggestions extends HTMLElement {
  swiper;
  connectedCallback() {
    const { $swiper } = this;
    this.swiper = new Swiper($swiper, Config);
  }
  disconnectedCallback() {
    this.swiper.destroy();
  }
  get $swiper() {
    return this.querySelector(`.swiper`);
  }
}

// Source/Article-Suggestions/mod.ts
customElements.define("article-suggestions", ArticleSuggestions);
